import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import RightArrow from '../../icons/RightArrow';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import Footer from '../../components/Footer';
import { getDateString } from '../../utils/Date';


export default function InquiryAnswer() {
  const location = useLocation();
  const inquiry = location.state
  const navigate = useNavigate();


  return (
    <ScreenContainer style={style.container}>
      <Header />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div style={style.title} className='mt-24'>{inquiry.title}</div>
        <div style={style.question} className='mt-8'>{inquiry.q}</div>
        <div style={style.date} className='mt-16'>답변 완료<span style={{ color: colors.mono300 }}> | {getDateString(inquiry.answerDate)}</span></div>
        <div style={style.card} className='mt-32'>
          <div style={style.cardTitle}>팀 아이어리 답변 내용</div>
          <div style={style.answer}>
            {inquiry.a}
          </div>
        </div>
        <Footer style={{ marginTop: 150 }} />
      </div>
    </ScreenContainer>

  );
}

const style = {
  container: {
    height: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  card: {
    backgroundColor: '#111D22',
    border: '1px solid transparent',
    borderRadius: 13,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    padding: '24px 20px',
    gap: 12
  },
  title: {
    ...typography.body['15_medium'],
    color: colors.white
  },
  question: {
    ...typography.body['14_regular'],
    color: colors.mono300
  },
  date: {
    ...typography.caption_12_regular,
    color: '#3BC4FF'
  },
  cardTitle: {
    ...typography.body['15_medium'],
    color: colors.white
  },
  answer: {
    ...typography.body['14_regular'],
    color: colors.mono300
  }
}